import { DocumentsCreateNewFolderMutationTypes } from "./mutation_types"
import { DocumentsCreateNewFolderState } from "./state"

export const mutations: StoreMutations<DocumentsCreateNewFolderMutationTypes, DocumentsCreateNewFolderState>  = {
  [DocumentsCreateNewFolderMutationTypes.SET_IS_OPEN]: function (state, value) {
    state.isOpen = value
  },
  [DocumentsCreateNewFolderMutationTypes.SET_LOADING]: function (state, value) {
    state.loading = value
  },
}
